import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem } from '@twistopayments/design-system/styles'

export const navigation = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;
  width: 100%;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const centered = css`
  ${breakpoint.up('smMd')} {
    text-align: center;
  }
`
